import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

export const DASHBOARD_PAGE_TEXTS = {
    CAPTION: 'friend-referral-program',
    TITLE: 'dashboard-page__title',
    SUBTITLE: 'dashboard-page__subtitle'
};

export const DEFAULT_STAT_VALUE = 0;

export const GET_ANALYTICS_DASHBOARD_DATA = () => ({
    flowStep: 'referral dashboard',
    category: CATEGORY.DISPLAY,
    action: 'referral dashboard'
});
